import { Link } from "react-router-dom";

export default function old1_PublicSiteFooter() {
  return (
    <footer className="site-footer jw-public-footer">
      <div className="footer-inner jw-public-footer__inner">
        <div className="footer-brand">
          <h3>JOBUWIN.com</h3>
          <p>Building a trusted hiring platform for real people and real opportunities.</p>
          <p>
            <a href="mailto:hello@JOBUWIN.com">hello@JOBUWIN.com</a>
          </p>
          <p>Copyright 2026 JOBUWIN.com. All rights reserved.</p>
        </div>

        <div className="footer-links">
          <Link to="/old1/home">Home</Link>
          <Link to="/old1/blog">Blog</Link>
          <Link to="/old1/terms">Terms of Use</Link>
          <Link to="/old1/privacy">Privacy Policy</Link>
        </div>

        <div className="footer-extra">
          <p className="footer-company">JOBUWIN is owned and operated by MotoMob Limited.</p>
          <p className="footer-company">MotoMob Limited is a company registered in England and Wales.</p>
          <p className="company-number">Company Number: 12560742</p>
        </div>
      </div>
    </footer>
  );
}
